import React, { Component } from "react";
import { connect } from "react-redux";
import {
  postResults,
  testsSelected,
  resetReducer,
  subtestResults,
  userUpdateWithMeasurementUnit as userUpdate,
  setPreferences,
  getAttachments,
  uploadAttachment,
  deleteAttachment,
  attachmentDownload,
  resetResultsState,
  hideResults,
  hideResultHeader,
  clearAttachments,
  userGet,
  postJob,
  clearResults,
  storeWiremapStandard,
  signaltekPostResults,
  signaltekClearResults,
  getsubtestSignaltekResults,
  setSignaltek,
  clearSignaltek,
  getNetScanResult,
  getsubtestWiremapResults,
  getsubtestFiberLengthLossResults,
  getsubtestPoeResults,
  getsubtestMaxthroughputResults,
  getsubtestUptimeResults,
  getsubtestUptimeResultsDetails,
  getsubtestUptimeResultsDetails_BarClick,
  getsubtestSubTestsettingsResults,
  clearSubTestSettingsResult,
  getStatsResult,
  customerSelect,
  checkSmartFlags,
  resetSmartFlags
} from "../../redux/actions";
import { preparePager } from "../../common/tabletools";
import { isSignalTEK10GType, isSmartFlagSupportedDevice } from "../../common/utils"
import Results from "../../components/results";
import SignaltekResults from "../../components/results/signaltekresults";
import NoData from "../../components/nodata";
import appHistory from "../../history";

class ResultsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pager: {
        //defaultColumns: ["ipaddress", "macaddress", "vendor", "host"],
        manual: true,
        pageno: 1,
        pagesize: 50,
        order: {},
        search: [],
        jid: this.props.match.params.jid,
        tid: this.props.match.params.tid,
        global: false
      }
    };
    this.smartFlagRefreshHandled = false;
    this.fetch = this.fetch.bind(this);
    //this.updatePaging = this.updatePaging.bind(this);
  }
  componentWillMount() {
    const { testsFilters, job } = this.props;
    if (job && !isSignalTEK10GType(job.deviceid)) {
      this.props.getResults(
        this.props.match.params.jid,
        this.props.match.params.tid,
        testsFilters
      );
    } else {
      this.props.signaltekPostResults(
        this.props.match.params.jid,
        this.props.match.params.tid,
        testsFilters
      );
    }
    if (this.props.profileReducer && this.props.profileReducer.profile)
      this.props.getCustomer(this.props.profileReducer.profile.customerid);
  }

  fetch(table) {
    const { pager } = this.state;
    if (!pager.global) {
      if (table.columns[1].id === "ipaddress") {
        this.props.getNetScanResult(preparePager(table, pager));
      } else {
        this.props.getsubtestUptimeResultsDetails(preparePager(table, pager));
      }
    } else {
      let search = pager.search;
      let pagers = preparePager(table, pager);
      if (pagers.search.length > 0) {
        pagers.search = [...search, ...pagers.search];
      } else {
        pagers.search = search;
      }

      if (table.columns[1].id === "ipaddress") {
        this.props.getNetScanResult(pagers);
      } else {
        this.props.getsubtestUptimeResultsDetails(pagers);
      }
    }
  }

  // updatePaging = pager => {
  //   this.setState({
  //     pager: pager
  //   });
  // };

  componentDidMount() {
    const { profile, currentLoggedInUserId, getUser, job, getJob } = this.props;
    if (!profile || profile.id !== currentLoggedInUserId) {
      getUser(currentLoggedInUserId);
    }
    const currentJobId = this.props.match.params.jid;
    getJob(currentJobId);
  }

  componentWillUnmount() {
    this.props.hideResults();
    this.props.hideResultHeader();
  }

  componentDidUpdate() {
    const {
      results,
      clearResults,
      signaltekResults,
      signaltekClearResults
    } = this.props;
    if (results && results.errors && results.errors === "error_no_permission") {
      clearResults();
      this.props.history.push("/jobs");
    }
    if (
      signaltekResults &&
      signaltekResults.errors &&
      signaltekResults.errors === "error_no_permission"
    ) {
      signaltekClearResults();
      this.props.history.push("/jobs");
    }

    this.refreshSmartFlagsAfterReturn();
  }

  openSmartFlagProfileEditor = () => {
    const { job } = this.props;

    if (!job || !job.effectiveSmartFlagProfileId) {
      return;
    }

    appHistory.push({
      pathname: `/smartflags/${job.effectiveSmartFlagProfileId}`,
      state: {
        returnTo: appHistory.location.pathname
      }
    });
  };

  refreshSmartFlagsAfterReturn() {
    if (this.smartFlagRefreshHandled) {
      return;
    }

    const refreshSmartFlags = this.props.location?.state?.refreshSmartFlags;
    const { job, match, resetSmartFlags } = this.props;

    if (!refreshSmartFlags) {
      return;
    }

    if (!job || `${job.id}` !== `${match.params.jid}`) {
      return;
    }

    this.smartFlagRefreshHandled = true;

    if (!isSmartFlagSupportedDevice(job.deviceid) || !job.effectiveSmartFlagProfileId) {
      resetSmartFlags();
      return;
    }

    this.props.checkSmartFlags(job.id);
  }

  render() {
    const {
      translate,
      job,
      results,
      match,
      testsFilters,
      selectedTests,
      setSelectedTests,
      getSubtestResults,
      getSubtestSignaltekResults,
      subtestResultsDisplay,
      subtestResultsRemote,
      resetReducer,
      subtestResultsWiremap,
      profile,
      userUpdate,
      setPreferences,
      preferences,
      attachments,
      getAttachments,
      uploadAttachment,
      deleteAttachment,
      attachmentDownload,
      resetResultsState,
      showResults,
      showResultHeader,
      selectedCustomerId,
      selectedCustomerName,
      clearAttachments,
      storeWiremapStandard,
      signaltekResults,
      subtestSignaltekResults,
      setSignaltek,
      clearSignaltek,
      getNetScanResult,
      netScanResultDetail,
      getsubtestWiremapResults,
      subtestWiremapResults,
      getsubtestFiberLengthLossResults,
      subtestFiberLengthLossResults,
      getsubtestPoeResults,
      subtestPoeResults,
      getsubtestMaxthroughputResults,
      subtestMaxthroughputResults,
      getsubtestUptimeResults,
      subtestUptimeResults,
      getsubtestUptimeResultsDetails,
      subtestUptimeResultsDetails,
      getsubtestUptimeResultsDetails_BarClick,
      subtestUptimeResultsDetails_BarClick,
      getsubtestSubTestsettingsResults,
      subtestSubTestSettingsResults,
      clearSubTestSettingsResult,
      getStatsResult,
      subtestStatsResults,
      customer,
      activeFeatures
    } = this.props;

    const showSmartFlagProfileContext =
      activeFeatures?.some(feature => feature.featureName === "smart_flag") &&
      job &&
      isSmartFlagSupportedDevice(job.deviceid);

    if (results && results.errors && results.errors === "error_no_permission") {
      return null;
    }

    if (
      signaltekResults &&
      signaltekResults.errors &&
      signaltekResults.errors === "error_no_permission"
    ) {
      return null;
    }

    if (job && results && !isSignalTEK10GType(job.deviceid)) {
      return (
        <Results
          job={job}
          results={results}
          translate={translate}
          pager={match.params}
          testsFilters={testsFilters}
          selectedTests={selectedTests}
          getResults={(jid, tid, pager) =>
            this.props.getResults(jid, tid, pager)
          }
          setSelectedTests={setSelectedTests}
          getSubtestResults={getSubtestResults}
          subtestResultsRemote={subtestResultsRemote}
          subtestResultsDisplay={subtestResultsDisplay}
          resetReducer={resetReducer}
          subtestResultsWiremap={subtestResultsWiremap}
          profile={profile}
          showResults={showResults}
          showResultHeader={showResultHeader}
          userUpdate={userUpdate}
          setPreferences={setPreferences}
          preferences={preferences}
          getAttachments={getAttachments}
          attachments={attachments}
          uploadAttachment={uploadAttachment}
          deleteAttachment={deleteAttachment}
          attachmentDownload={attachmentDownload}
          jobid={this.props.match.params.jid}
          testid={this.props.match.params.tid}
          resetResultsState={resetResultsState}
          selectedCustomerName={selectedCustomerName}
          selectedCustomerId={selectedCustomerId}
          clearAttachments={clearAttachments}
          storeWiremapStandard={storeWiremapStandard}
          customer={customer}
          showSmartFlagProfileContext={showSmartFlagProfileContext}
          onEditSmartFlagProfile={this.openSmartFlagProfileEditor}
        />
      );
    } else if (job && signaltekResults && isSignalTEK10GType(job.deviceid)) {
      return (
        <SignaltekResults
          job={job}
          results={signaltekResults}
          translate={translate}
          pager={this.state.pager}
          testsFilters={testsFilters}
          selectedTests={selectedTests}
          getResults={(jid, tid, pager) =>
            this.props.signaltekPostResults(jid, tid, pager)
          }
          setSelectedTests={setSelectedTests}
          getSubtestResults={getSubtestSignaltekResults}
          subtestSignaltekResults={subtestSignaltekResults}
          // subtestResultsRemote={subtestResultsRemote}
          // subtestResultsDisplay={subtestResultsDisplay}
          resetReducer={resetReducer}
          subtestResultsWiremap={subtestResultsWiremap}
          profile={profile}
          showResults={showResults}
          showResultHeader={showResultHeader}
          userUpdate={userUpdate}
          setPreferences={setPreferences}
          preferences={preferences}
          getAttachments={getAttachments}
          attachments={attachments}
          uploadAttachment={uploadAttachment}
          deleteAttachment={deleteAttachment}
          attachmentDownload={attachmentDownload}
          jobid={this.props.match.params.jid}
          testid={this.state.pager.tid}
          resetResultsState={resetResultsState}
          selectedCustomerName={selectedCustomerName}
          selectedCustomerId={selectedCustomerId}
          clearAttachments={clearAttachments}
          storeWiremapStandard={storeWiremapStandard}
          setSignaltek={setSignaltek}
          clearSignaltek={clearSignaltek}
          getNetScanResult={getNetScanResult}
          netScanResultDetail={netScanResultDetail}
          fetch={this.fetch}
          getsubtestWiremapResults={getsubtestWiremapResults}
          subtestWiremapResults={subtestWiremapResults}
          getsubtestFiberLengthLossResults={getsubtestFiberLengthLossResults}
          subtestFiberLengthLossResults={subtestFiberLengthLossResults}
          getsubtestPoeResults={getsubtestPoeResults}
          subtestPoeResults={subtestPoeResults}
          getsubtestMaxthroughputResults={getsubtestMaxthroughputResults}
          subtestMaxthroughputResults={subtestMaxthroughputResults}
          getsubtestUptimeResults={getsubtestUptimeResults}
          subtestUptimeResults={subtestUptimeResults}
          getsubtestUptimeResultsDetails={getsubtestUptimeResultsDetails}
          subtestUptimeResultsDetails={subtestUptimeResultsDetails}
          getsubtestUptimeResultsDetails_BarClick={
            getsubtestUptimeResultsDetails_BarClick
          }
          subtestUptimeResultsDetails_BarClick={
            subtestUptimeResultsDetails_BarClick
          }
          getsubtestSubTestsettingsResults={getsubtestSubTestsettingsResults}
          subtestSubTestSettingsResults={subtestSubTestSettingsResults}
          clearSubTestSettingsResult={clearSubTestSettingsResult}
          getStatsResult={getStatsResult}
          subtestStatsResults={subtestStatsResults}
          showSmartFlagProfileContext={showSmartFlagProfileContext}
          onEditSmartFlagProfile={this.openSmartFlagProfileEditor}
          //updatePaging={this.updatePaging}
        />
      );
    } else {
      return <NoData translate={translate} />;
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      testsFilters,
      job,
      getJob,
      subtestUptimeResultsDetails_BarClick
    } = nextProps;

    if (
      this.props.match.params.tid !== nextProps.match.params.tid ||
      job !== this.props.job
    ) {
      this.props.hideResults();
      if (job && !isSignalTEK10GType(job.deviceid)) {
        this.props.getResults(
          this.props.match.params.jid,
          nextProps.match.params.tid,
          testsFilters
        );
      } else {
        this.props.signaltekPostResults(
          this.props.match.params.jid,
          nextProps.match.params.tid,
          testsFilters
        );
        this.setState({
          pager: {
            ...this.state.pager,
            tid: nextProps.match.params.tid
          }
        });
      }
    } else {
      const currentJobId = this.props.match.params.jid;
      if (!job) {
        getJob(currentJobId);
      }
    }
    // if (
    //   // subtestUptimeResultsDetails_BarClick != this.state.pager.pageno &&
    //   this.props.subtestUptimeResultsDetails_BarClick !=
    //   subtestUptimeResultsDetails_BarClick
    // ) {
    //   //this.state.pager;
    //   let pager = { ...this.state.pager };
    //   pager.pageno = subtestUptimeResultsDetails_BarClick;
    //   this.setState({
    //     pager
    //   });
    //   this.props.getsubtestUptimeResultsDetails(pager);
    // }
  }
}

const mapStateToProps = state => {
  let tempvalue = {
    subtesttypeid: "ping4",
    totaltargets: "3",
    targetspassed: "2",
    targetsfailed: "1",
    testduration: "10",
    teststarted: "8.7.2020",
    subteststatus: "Pass",
    pingdata: [
      {
        status: "Pass",
        target: "www.google.com",
        info: "Pass",
        txcount: 0,
        rxcount: 0,
        min: 3.3,
        avg: 3.3,
        max: 3.3
      },
      {
        status: "Fail",
        target: "www.cloudthing.com",
        info: "fail",
        txcount: 1,
        rxcount: 1,
        min: 3.5,
        avg: 3.5,
        max: 3.5
      }
    ]
  };
  return {
    job: state.jobReducer.job,
    results: state.resultReducer.results,
    testsFilters: state.testsReducer.filters,
    selectedTests: state.testsReducer.selected,
    subtestResultsRemote: state.resultReducer.subtestResultsRemote,
    subtestResultsDisplay: state.resultReducer.subtestResultsDisplay,
    subtestResultsWiremap: state.resultReducer.subtestResultsWiremap,
    profile: state.userReducer.user,
    preferences: state.resultReducer.preferences,
    attachments: state.testsReducer.attachments,
    showResults: state.resultReducer.showResults,
    showResultHeader: state.resultReducer.showResultHeader,
    selectedCustomerId: state.jobReducer.selectedCustomerId,
    selectedCustomerName: state.jobReducer.selectedCustomerName,
    currentLoggedInUserId: state.userReducer.currentLoggedInUserId,
    signaltekResults: state.resultReducer.signaltekResults,
    subtestSignaltekResults: state.resultReducer.subtestSignaltekResults,
    netScanResultDetail: state.resultReducer.netScanResultDetail,
    subtestWiremapResults: state.resultReducer.subtestWiremapResults,
    subtestFiberLengthLossResults: state.resultReducer.subtestFiberLengthLossResults,
    subtestPoeResults: state.resultReducer.subtestPoeResults,
    subtestMaxthroughputResults:
      state.resultReducer.subtestMaxthroughputResults,
    subtestUptimeResults: state.resultReducer.subtestUptimeResults,
    subtestUptimeResultsDetails:
      state.resultReducer.subtestUptimeResultsDetails,
    subtestUptimeResultsDetails_BarClick:
      state.resultReducer.subtestUptimeResultsDetails_BarClick,
    subtestSubTestSettingsResults:
      state.resultReducer.subtestSubTestSettingsResults,
    subtestStatsResults: state.resultReducer.subtestStatsResults,
    customer: state.customerReducer.customer,
    activeFeatures: state.appSettingReducer.activeFeatures,
    fileUploadSettings: state.appSettingReducer.fileUploadSettings,
    ...state
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  getResults: (jid, tid, pager) => {
    pager = { ...pager, ...{ pageno: 0, pagesize: 0 } };
    dispatch(postResults(jid, tid, pager));
  },
  signaltekPostResults: (jid, tid, pager) => {
    pager = { ...pager, ...{ pageno: 0, pagesize: 0 } };
    dispatch(signaltekPostResults(jid, tid, pager));
  },
  setSelectedTests: tests => {
    dispatch(testsSelected(tests));
  },
  getSubtestResults: (jid, tid, type, device) => {
    dispatch(subtestResults(jid, tid, type, device));
  },
  getSubtestSignaltekResults: (jid, tid, type) => {
    dispatch(getsubtestSignaltekResults(jid, tid, type));
  },
  resetReducer: () => {
    dispatch(resetReducer());
  },
  userUpdate: data => {
    dispatch(userUpdate(data));
  },
  setPreferences: prefs => {
    dispatch(setPreferences(prefs));
  },
  getAttachments: (jobid, testid) => {
    dispatch(getAttachments(jobid, testid));
  },
  uploadAttachment: (file, jobid, testid) => {
    dispatch(uploadAttachment(file, jobid, testid));
  },
  deleteAttachment: file => {
    dispatch(deleteAttachment(file));
  },
  attachmentDownload: file => {
    dispatch(attachmentDownload(file));
  },
  resetResultsState: () => {
    dispatch(resetResultsState());
  },
  hideResults: () => {
    dispatch(hideResults());
  },
  hideResultHeader: () => {
    dispatch(hideResultHeader());
  },
  clearAttachments: () => {
    dispatch(clearAttachments());
  },
  getUser: id => {
    dispatch(userGet(id));
  },
  getJob: id => {
    dispatch(postJob(id));
  },
  clearResults: () => {
    dispatch(clearResults());
  },
  storeWiremapStandard: (jobid, wiremapcolor) => {
    dispatch(storeWiremapStandard(jobid, wiremapcolor));
  },
  checkSmartFlags: jobId => {
    return dispatch(checkSmartFlags(jobId));
  },
  resetSmartFlags: () => {
    dispatch(resetSmartFlags());
  },
  signaltekClearResults: () => {
    dispatch(signaltekClearResults());
  },
  setSignaltek: () => {
    dispatch(setSignaltek());
  },
  clearSignaltek: () => {
    dispatch(clearSignaltek());
  },
  getNetScanResult: pager => {
    dispatch(getNetScanResult(pager));
  },
  getsubtestWiremapResults: (jid, tid, type) => {
    dispatch(getsubtestWiremapResults(jid, tid, type));
  },
  getsubtestFiberLengthLossResults: (jid, tid, type) => {
    dispatch(getsubtestFiberLengthLossResults(jid, tid, type));
  },
  getsubtestPoeResults: (jid, tid, type) => {
    dispatch(getsubtestPoeResults(jid, tid, type));
  },
  getsubtestMaxthroughputResults: (jid, tid, type) => {
    dispatch(getsubtestMaxthroughputResults(jid, tid, type));
  },
  getsubtestUptimeResults: (jid, tid, type) => {
    dispatch(getsubtestUptimeResults(jid, tid, type));
  },
  getsubtestUptimeResultsDetails: pager => {
    return dispatch(getsubtestUptimeResultsDetails(pager));
  },
  getsubtestUptimeResultsDetails_BarClick: item => {
    return dispatch(getsubtestUptimeResultsDetails_BarClick(item));
  },
  getsubtestSubTestsettingsResults: (jid, tid, type) => {
    dispatch(getsubtestSubTestsettingsResults(jid, tid, type));
  },
  clearSubTestSettingsResult: () => {
    dispatch(clearSubTestSettingsResult());
  },
  getStatsResult: (jid, tid, type) => {
    dispatch(getStatsResult(jid, tid, type));
  },
  getCustomer: id => {
    dispatch(customerSelect(id));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResultsPage);
